import React, { useEffect, useState } from "react";
import css from "./Cookies.module.css";
import { Link } from "react-router-dom";
import illustration from "../../assets/hero.png";

export default function CookiesPage() {
  const [consent, setConsent] = useState(null);

  useEffect(() => {
    const raw = localStorage.getItem("cookie-consent");
    try {
      const parsed = raw ? JSON.parse(raw) : raw;
      setConsent(parsed || null);
    } catch {
      setConsent(raw || null);
    }
  }, []);

  function clearConsent() {
    localStorage.removeItem("cookie-consent");
    setConsent(null);
    window.location.reload(); // optional — refresh so banner reappears
  }

  return (
    <main className={css.page}>
      <div className={css.hero}>
        <div className={css.heroText}>
          <h1>Política de Cookies</h1>
          <p className={css.lead}>
            Entenda como utilizamos cookies e outras tecnologias similares para
            garantir segurança, autenticação e melhorar sua experiência.
          </p>
          <div className={css.metaRow}>
            <span className={css.metaBadge}>Essenciais</span>
            <span className={css.metaBadge}>Funcionais</span>
            <span className={css.metaBadge}>Analytics (opt-in)</span>
          </div>
        </div>

        <figure className={css.heroImageWrap} aria-hidden>
          <img src={illustration} alt="" className={css.heroImage} />
        </figure>
      </div>

      <section className={css.container}>
        <article className={css.card}>
          <h2>O que são cookies?</h2>
          <p>
            Cookies são pequenos arquivos de texto armazenados no dispositivo do
            usuário para identificar o navegador, lembrar preferências e
            melhorar a experiência. Usamos cookies apenas quando necessário e
            sempre com transparência.
          </p>
        </article>

        <article className={css.card}>
          <h2>Quais cookies usamos</h2>

          <h3>1. Essenciais / Técnicos</h3>
          <p>
            Necessários para autenticação (Firebase Auth), segurança e para que
            a teleconsulta via Jitsi funcione corretamente. Esses cookies não
            requerem consentimento, pois são imprescindíveis ao funcionamento.
          </p>

          <h3>2. Funcionais</h3>
          <p>
            Lembram preferências do usuário, idioma e ajustes de interface.
            Melhoram a usabilidade, mas podem ser desativados sem perda crítica
            de funcionalidades.
          </p>

          <h3>3. Analytics / Desempenho</h3>
          <p>
            Usamos ferramentas de medição (ex.: Google Analytics) apenas se você
            autorizar. Esses cookies ajudam a entender padrões de uso e a
            melhorar conteúdos e fluxos.
          </p>
        </article>

        <article className={css.card}>
          <h2>Consentimento e controle</h2>
          <p>
            Ao acessar o site pela primeira vez, você verá um banner de cookies
            com as opções: <strong>Aceitar</strong>, <strong>Recusar</strong> e{" "}
            <strong>Configurar</strong>. Suas preferências são salvas em
            <code>localStorage</code>.
          </p>

          <div className={css.controls}>
            <div>
              <strong>Status atual:</strong>{" "}
              <span className={css.status}>
                {consent === null
                  ? "Sem decisão"
                  : typeof consent === "string"
                  ? consent
                  : JSON.stringify(consent)}
              </span>
            </div>

            <div className={css.controlsBtns}>
              <button
                className={css.btnGhost}
                onClick={() => window.location.reload()}
              >
                Reaparecer banner
              </button>
              <button className={css.btnDanger} onClick={clearConsent}>
                Limpar preferência
              </button>
            </div>
          </div>
        </article>

        <article className={css.card}>
          <h2>Consequências de recusar</h2>
          <p>
            Se recusar cookies de analytics, não perderá o acesso básico à
            plataforma. No entanto, recusar cookies essenciais pode impedir o
            login e a realização de teleconsultas.
          </p>

          <h3>Como desativar cookies no navegador</h3>
          <p>
            Você pode gerenciar ou desativar cookies nas configurações do seu
            navegador (Chrome, Firefox, Safari etc.). Lembre-se: desativar
            cookies essenciais pode afetar o funcionamento.
          </p>
        </article>

        <article className={css.cardSmall}>
          <h3>Dúvidas? Contato</h3>
          <p>
            Para solicitações relacionadas à privacidade e cookies, encaminhe
            e-mail para <strong>institutobhava@gmail.com</strong>.
          </p>
          <p className={css.linkRow}>
            <Link to="/privacy" className={css.inlineLink}>
              Política de Privacidade
            </Link>
            <Link to="/terms" className={css.inlineLink}>
              Termos de Uso
            </Link>
          </p>
        </article>
      </section>
    </main>
  );
}
